import api from "../../../core/api/config";

const USE_REAL_RASTREAMENTO_ITENS = true;
const USE_REAL_RASTREAMENTO_CONVOCAR = true;
const USE_REAL_RASTREAMENTO_EXPORTAR = true;
const USE_REAL_SEGUIMENTO_ITENS = true;
const USE_REAL_SEGUIMENTO_CONVOCAR = true;
const USE_REAL_SEGUIMENTO_EXPORTAR = true;

const wait = (ms = 250) => new Promise((resolve) => setTimeout(resolve, ms));

const categoriaLabels = {
  ALTA: "Alta",
  BAIXA: "Baixa",
  MEDIA: "Média",
  MAXIMA: "Máxima",
  EM_DIA: "Em dia",
  BIRADS_3: "Repetição de mamografia",
  ULTRASSON: "Ultrassom",
  MASTOLOGISTA: "Encaminhar mastologista",
  BIOPSIA: "Biópsia em atraso",
  ALTERADOS: "Alterado",
  ALTERADO: "Alterado",
  INSATISFATORIO: "Insatisfatório",
  COLPOSCOPIA: "Colposcopia",
  TRATAMENTO: "Tratamento",
};

const seguimentoCategorias = {
  colo: [
    { id: "INSATISFATORIO", label: "Insatisfatório" },
    { id: "ALTERADOS", label: "Alterado" },
    { id: "COLPOSCOPIA", label: "Colposcopia" },
    { id: "TRATAMENTO", label: "Tratamento" },
  ],
  mama: [
    { id: "BIRADS_3", label: "Repetição de mamografia" },
    { id: "MASTOLOGISTA", label: "Encaminhar mastologista" },
    { id: "ULTRASSON", label: "Ultrassom" },
    { id: "BIOPSIA", label: "Biópsia em atraso" },
  ],
};

const formatCategorias = (categorias = {}) =>
  Object.entries(categorias)
    .map(([categoria, total]) => `${categoriaLabels[categoria] || categoria}: ${total}`)
    .join(" | ");

const monthLabels = [
  { value: 1, label: "Janeiro" },
  { value: 2, label: "Fevereiro" },
  { value: 3, label: "Março" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Maio" },
  { value: 6, label: "Junho" },
  { value: 7, label: "Julho" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Setembro" },
  { value: 10, label: "Outubro" },
  { value: 11, label: "Novembro" },
  { value: 12, label: "Dezembro" },
];

let rastreamentoRows = [
  {
    id: 1,
    nome: "Maria Helena Castro",
    cpf: "38260964104",
    idade: 74,
    exame: "Mama",
    ultimoExame: "2025-11-03",
    prazoRecomendado: "2027-11-03",
    ubs: "UBS Centro",
    telefone: "(11) 99999-9999",
    endereco: "Rua das Flores, 123 - São Paulo/SP",
    anoConvocacao: 2027,
    mesConvocacao: 2,
    convocada: false,
  },
  {
    id: 2,
    nome: "Luzia Souza Silva",
    cpf: "54011892010",
    idade: 58,
    exame: "Mama",
    ultimoExame: "2024-08-15",
    prazoRecomendado: "2026-08-15",
    ubs: "UBS Vila Nova",
    telefone: "(11) 98888-2233",
    endereco: "Rua Primavera, 88 - São Paulo/SP",
    anoConvocacao: 2026,
    mesConvocacao: 8,
    convocada: true,
  },
  {
    id: 3,
    nome: "Patricia Gomes Araujo",
    cpf: "85799064032",
    idade: 53,
    exame: "Mama",
    ultimoExame: "2023-01-11",
    prazoRecomendado: "2025-01-11",
    ubs: "UBS Aeroporto",
    telefone: "(11) 97777-7001",
    endereco: "Rua Afonso Pena, 20 - São Paulo/SP",
    anoConvocacao: 2025,
    mesConvocacao: 1,
    convocada: false,
  },
  {
    id: 4,
    nome: "Rita de Cassia Nunes",
    cpf: "18710057048",
    idade: 61,
    exame: "Mama",
    ultimoExame: "2022-12-20",
    prazoRecomendado: "2024-12-20",
    ubs: "UBS Jardim São Paulo",
    telefone: "(11) 96666-4002",
    endereco: "Av. Central, 455 - São Paulo/SP",
    anoConvocacao: 2024,
    mesConvocacao: 12,
    convocada: true,
  },
  {
    id: 5,
    nome: "Neide Prado Martins",
    cpf: "38721754092",
    idade: 64,
    exame: "Mama",
    ultimoExame: "2024-06-02",
    prazoRecomendado: "2026-06-02",
    ubs: "UBS Bela Vista",
    telefone: "(11) 95555-1004",
    endereco: "Rua XV de Novembro, 90 - São Paulo/SP",
    anoConvocacao: 2026,
    mesConvocacao: 6,
    convocada: false,
  },
  {
    id: 6,
    nome: "Daniela Pires da Rocha",
    cpf: "36578286085",
    idade: 49,
    exame: "Colo",
    ultimoExame: "2021-10-19",
    prazoRecomendado: "2024-10-19",
    ubs: "UBS Centro",
    telefone: "(11) 94444-0213",
    endereco: "Rua das Palmeiras, 300 - São Paulo/SP",
    anoConvocacao: 2024,
    mesConvocacao: 10,
    convocada: false,
  },
  {
    id: 7,
    nome: "Eliane Fernandes Lima",
    cpf: "62474696015",
    idade: 34,
    exame: "Colo",
    ultimoExame: "2020-03-09",
    prazoRecomendado: "2023-03-09",
    ubs: "UBS Vila Nova",
    telefone: "(11) 93333-2230",
    endereco: "Rua Sol, 99 - São Paulo/SP",
    anoConvocacao: 2023,
    mesConvocacao: 3,
    convocada: true,
  },
  {
    id: 8,
    nome: "Gabriela Teixeira Sousa",
    cpf: "47300901012",
    idade: 27,
    exame: "Colo",
    ultimoExame: "2022-11-07",
    prazoRecomendado: "2025-11-07",
    ubs: "UBS Cruzeiro",
    telefone: "(11) 92222-8899",
    endereco: "Rua Norte, 110 - São Paulo/SP",
    anoConvocacao: 2025,
    mesConvocacao: 11,
    convocada: false,
  },
  {
    id: 9,
    nome: "Silvia Ramos dos Santos",
    cpf: "47311843040",
    idade: 45,
    exame: "Colo",
    ultimoExame: "2021-09-28",
    prazoRecomendado: "2024-09-28",
    ubs: "UBS Alto da Serra",
    telefone: "(11) 91111-7700",
    endereco: "Rua Serra Azul, 45 - São Paulo/SP",
    anoConvocacao: 2024,
    mesConvocacao: 9,
    convocada: false,
  },
  {
    id: 10,
    nome: "Jaqueline Rosa de Souza",
    cpf: "86935723000",
    idade: 42,
    exame: "Colo",
    ultimoExame: "2022-02-10",
    prazoRecomendado: "2025-02-10",
    ubs: "UBS Campos Eliseos",
    telefone: "(11) 90000-4040",
    endereco: "Rua das Nações, 777 - São Paulo/SP",
    anoConvocacao: 2025,
    mesConvocacao: 2,
    convocada: true,
  },
  {
    id: 11,
    nome: "Marcia Regina Moreira",
    cpf: "23800787012",
    idade: 56,
    exame: "Mama",
    ultimoExame: "2023-04-14",
    prazoRecomendado: "2025-04-14",
    ubs: "UBS Vila Nova",
    telefone: "(11) 98989-1212",
    endereco: "Rua Mário Fava, 66 - São Paulo/SP",
    anoConvocacao: 2025,
    mesConvocacao: 4,
    convocada: false,
  },
  {
    id: 12,
    nome: "Carla Pereira Nogueira",
    cpf: "50141806085",
    idade: 51,
    exame: "Mama",
    ultimoExame: "2022-07-08",
    prazoRecomendado: "2024-07-08",
    ubs: "UBS Bela Vista",
    telefone: "(11) 97878-3333",
    endereco: "Rua Pio XII, 410 - São Paulo/SP",
    anoConvocacao: 2024,
    mesConvocacao: 7,
    convocada: false,
  },
  {
    id: 13,
    nome: "Ana Lucia de Oliveira",
    cpf: "87273271044",
    idade: 39,
    exame: "Colo",
    ultimoExame: "2019-12-22",
    prazoRecomendado: "2022-12-22",
    ubs: "UBS Aeroporto",
    telefone: "(11) 96767-9090",
    endereco: "Rua Frei Caneca, 12 - São Paulo/SP",
    anoConvocacao: 2022,
    mesConvocacao: 12,
    convocada: false,
  },
  {
    id: 14,
    nome: "Priscila Moura Gomes",
    cpf: "78435598067",
    idade: 46,
    exame: "Colo",
    ultimoExame: "2020-06-01",
    prazoRecomendado: "2023-06-01",
    ubs: "UBS Santa Clara",
    telefone: "(11) 95656-6565",
    endereco: "Rua do Bosque, 83 - São Paulo/SP",
    anoConvocacao: 2023,
    mesConvocacao: 6,
    convocada: true,
  },
  {
    id: 15,
    nome: "Rosana Barros Mendes",
    cpf: "12990484031",
    idade: 52,
    exame: "Mama",
    ultimoExame: "2021-11-04",
    prazoRecomendado: "2023-11-04",
    ubs: "UBS Cruzeiro",
    telefone: "(11) 94545-1000",
    endereco: "Rua Lisboa, 203 - São Paulo/SP",
    anoConvocacao: 2023,
    mesConvocacao: 11,
    convocada: false,
  },
];

let seguimentoRows = [
  {
    id: 101,
    nome: "Marta Gonçalves Ribeiro",
    cpf: "10980505011",
    idade: 50,
    exame: "Mama",
    ultimoExame: "2026-05-20",
    alteracao: "Bi-RADS 4 - suspeito",
    prioridade: "Alta",
    ubs: "UBS Centro",
    convocada: false,
  },
  {
    id: 102,
    nome: "Isabel Cristina Mota",
    cpf: "56364484062",
    idade: 44,
    exame: "Colo",
    ultimoExame: "2026-04-02",
    alteracao: "ASC-H",
    prioridade: "Alta",
    ubs: "UBS Campos Eliseos",
    convocada: true,
  },
  {
    id: 103,
    nome: "Maria de Fatima Reis",
    cpf: "88403949064",
    idade: 57,
    exame: "Mama",
    ultimoExame: "2026-03-01",
    alteracao: "Biópsia positiva",
    prioridade: "Alta",
    ubs: "UBS Vila Nova",
    convocada: false,
  },
  {
    id: 104,
    nome: "Angela Duarte Franco",
    cpf: "47202376053",
    idade: 36,
    exame: "Colo",
    ultimoExame: "2026-01-18",
    alteracao: "Lesão intraepitelial de alto grau",
    prioridade: "Média",
    ubs: "UBS Jardim São Paulo",
    convocada: false,
  },
  {
    id: 105,
    nome: "Lilian Pacheco Teles",
    cpf: "28185013007",
    idade: 63,
    exame: "Mama",
    ultimoExame: "2025-12-12",
    alteracao: "Bi-RADS 3",
    prioridade: "Média",
    ubs: "UBS Santa Clara",
    convocada: true,
  },
  {
    id: 106,
    nome: "Soraia Nascimento Cunha",
    cpf: "19923595057",
    idade: 47,
    exame: "Colo",
    ultimoExame: "2025-11-10",
    alteracao: "ASC-US persistente",
    prioridade: "Baixa",
    ubs: "UBS Bela Vista",
    convocada: false,
  },
];

const normalizeText = (value) =>
  (value || "")
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const matchesSearch = (row, search) => {
  if (!search) return true;
  const normalizedSearch = normalizeText(search);
  const normalizedName = normalizeText(row.nome);
  const normalizedCpf = normalizeText(row.cpf);
  const normalizedUbs = normalizeText(row.ubs);
  return (
    normalizedName.includes(normalizedSearch) ||
    normalizedCpf.includes(normalizedSearch) ||
    normalizedUbs.includes(normalizedSearch)
  );
};

const filterByExam = (rows, exam) => {
  if (!exam || exam === "TODOS") return rows;
  return rows.filter((row) => row.exame === exam);
};

const paginate = (rows, page, size) => {
  const start = page * size;
  return {
    total: rows.length,
    items: rows.slice(start, start + size),
  };
};

const buildRastreamentoDashboard = (rows) => {
  const colo = rows.filter((row) => row.exame === "Colo").length;
  const mama = rows.filter((row) => row.exame === "Mama").length;
  return [
    {
      id: "colo",
      title: "Total Convocação Colo",
      value: colo,
      colorClass: "text-primary",
    },
    {
      id: "mama",
      title: "Total Convocação Mama",
      value: mama,
      colorClass: "text-warning",
    },
  ];
};

const buildYears = (rows) => {
  const counts = rows.reduce((acc, row) => {
    acc[row.anoConvocacao] = (acc[row.anoConvocacao] || 0) + 1;
    return acc;
  }, {});

  return Object.keys(counts)
    .map((key) => Number(key))
    .sort((a, b) => a - b)
    .map((year) => ({
      year,
      total: counts[year],
    }));
};

const toCsv = (rows) => {
  const headers = [
    "Nome",
    "CPF",
    "Idade",
    "Exame",
    "Último Exame",
    "UBS",
    "Situação",
  ];
  const body = rows.map((row) => [
    row.nome,
    row.cpf,
    row.idade,
    row.exame,
    row.ultimoExame,
    row.ubs,
    row.convocada ? "Convocada" : "Pendente",
  ]);

  return [headers, ...body]
    .map((line) => line.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(";"))
    .join("\n");
};

export const fetchConvocacaoRastreamento = async ({
  exame,
  ano,
  mes,
  busca,
  status,
  idOrganograma,
  page,
  size,
}) => {
  if (USE_REAL_RASTREAMENTO_ITENS) {
    const tipoRastreamento = exame === "Mama" ? "MAMA" : exame === "Colo" ? "CITO" : undefined;
    const [itensResponse, dashboardResponse] = await Promise.all([
      api.get("/api/tracking/convocacoes/itens", {
        params: {
          origem: "RASTREAMENTO",
          idOrganograma,
          tipoRastreamento,
          ano: ano || undefined,
          mes: mes || undefined,
          status: status || undefined,
          page,
          size,
        },
      }),
      api
        .get("/api/tracking/convocacoes/dashboard", {
          params: {
            origem: "RASTREAMENTO",
            idOrganograma,
            ano: ano || undefined,
            mes: mes || undefined,
          },
        })
        .catch((error) => {
          if (error.response?.status === 404) return { data: null };
          throw error;
        }),
    ]);

    const data = itensResponse.data;
    const dashboard = dashboardResponse.data || {
      cito: {
        totalPacientes: rastreamentoRows.filter((row) => row.exame === "Colo").length,
        pendentes: rastreamentoRows.filter((row) => row.exame === "Colo" && !row.convocada).length,
        realizadas: rastreamentoRows.filter((row) => row.exame === "Colo" && row.convocada).length,
        anos: buildYears(rastreamentoRows.filter((row) => row.exame === "Colo")).map((item) => ({
          ano: item.year,
          total: item.total,
        })),
      },
      mama: {
        totalPacientes: rastreamentoRows.filter((row) => row.exame === "Mama").length,
        pendentes: rastreamentoRows.filter((row) => row.exame === "Mama" && !row.convocada).length,
        realizadas: rastreamentoRows.filter((row) => row.exame === "Mama" && row.convocada).length,
        anos: buildYears(rastreamentoRows.filter((row) => row.exame === "Mama")).map((item) => ({
          ano: item.year,
          total: item.total,
        })),
      },
    };
    const dashboardGroups = [
      { key: "cito", exam: "Colo", title: "Citologia do colo do útero" },
      { key: "mama", exam: "Mama", title: "Mamografia" },
    ];
    const mesLabel = monthLabels.find((item) => item.value === mes)?.label;

    return {
      dashboard: dashboardGroups.map(({ key, title }) => ({
        id: key,
        title,
        value: dashboard[key]?.totalPacientes || 0,
      })),
      rastreamentoPainel: dashboardGroups.map(({ key, exam, title }) => ({
        exam,
        title,
        totalMulheres: dashboard[key]?.totalPacientes || 0,
        totalMes: mesLabel && (exame === exam || exame === "TODOS")
          ? data?.totalElements ?? data?.content?.length ?? 0
          : null,
        mesLabel: mesLabel && (exame === exam || exame === "TODOS") ? mesLabel : null,
        categorias: formatCategorias(dashboard[key]?.categorias),
        years: (dashboard[key]?.anos || []).map((item) => ({
          year: item.ano,
          total: item.total,
        })),
      })),
      statusCards: dashboardGroups.flatMap(({ key, title }) => [
        {
          id: `${key}-pendente`,
          title,
          subTitle: "Pendentes de convocação",
          value: dashboard[key]?.pendentes || 0,
          tone: "warning",
        },
        {
          id: `${key}-realizada`,
          title,
          subTitle: "Convocações realizadas",
          value: dashboard[key]?.realizadas || 0,
          tone: "success",
        },
      ]),
      years: (dashboard.cito?.anos || []).map((item) => ({
        year: item.ano,
        total: item.total,
      })),
      months: monthLabels,
      table: {
        items: (data?.content || []).map((item) => ({
          id: item.id,
          pessoaId: item.pessoaId,
          nome: item.paciente,
          convocacaoPermitida: item.convocacaoPermitida,
          motivoBloqueioConvocacao: item.motivoBloqueioConvocacao,
          anoPlanejado: item.anoPlanejado,
          mesPlanejado: item.mesPlanejado,
          dataReferencia: item.dataReferencia,
          statusGeralRastreamento: item.statusGeralRastreamento,
          cpf: item.cpf,
          idade: item.idade,
          exame: item.exameIndicado,
          ultimoExame: item.dataReferencia,
          prazoRecomendado: item.dataValidadeDiretriz,
          ubs: item.ubs,
          telefone: item.telefone,
          endereco: item.endereco,
          convocada: item.status === "CONVOCADO",
          status: item.status,
        })),
        total: data?.totalElements ?? data?.content?.length ?? 0,
      },
    };
  }

  await wait();

  const byExam = filterByExam(rastreamentoRows, exame);
  const byYear = ano ? byExam.filter((row) => row.anoConvocacao === ano) : byExam;
  const byMonth = mes ? byYear.filter((row) => row.mesConvocacao === mes) : byYear;
  const filtered = byMonth.filter((row) => matchesSearch(row, busca));

  const sorted = [...filtered].sort(
    (a, b) => new Date(a.prazoRecomendado) - new Date(b.prazoRecomendado),
  );
  const pagination = paginate(sorted, page, size);

  return {
    dashboard: buildRastreamentoDashboard(byMonth),
    years: buildYears(byExam),
    months: monthLabels,
    table: pagination,
  };
};

export const fetchConvocacaoSeguimento = async ({
  exame,
  prioridade,
  busca,
  idOrganograma,
  page,
  size,
}) => {
  if (USE_REAL_SEGUIMENTO_ITENS) {
    const tipoRastreamento = exame === "Mama" ? "MAMA" : exame === "Colo" ? "CITO" : undefined;
    const [itensResponse, dashboardResponse] = await Promise.all([
      api.get("/api/tracking/convocacoes/itens", {
        params: {
          origem: "SEGUIMENTO",
          idOrganograma,
          tipoRastreamento,
          ano: undefined,
          mes: undefined,
          categoria: prioridade && prioridade !== "TODAS" ? prioridade : undefined,
          status: undefined,
          page,
          size,
        },
      }),
      api.get("/api/tracking/convocacoes/dashboard", {
        params: {
          origem: "SEGUIMENTO",
          idOrganograma,
        },
      }),
    ]);

    const data = itensResponse.data;
    const dashboard = dashboardResponse.data || {};

    return {
      categorias: seguimentoCategorias,
      statusCards: [
        {
          id: "seg-cito-pendente",
          title: "Citologia do colo do útero",
          subTitle: "Pendentes de convocação",
          value: dashboard.cito?.pendentes || 0,
          categorias: formatCategorias(dashboard.cito?.categorias),
          tone: "warning",
        },
        {
          id: "seg-cito-realizada",
          title: "Citologia do colo do útero",
          subTitle: "Convocações realizadas",
          value: dashboard.cito?.realizadas || 0,
          categorias: formatCategorias(dashboard.cito?.categorias),
          tone: "success",
        },
        {
          id: "seg-mama-pendente",
          title: "Mamografia",
          subTitle: "Pendentes de convocação",
          value: dashboard.mama?.pendentes || 0,
          categorias: formatCategorias(dashboard.mama?.categorias),
          tone: "warning",
        },
        {
          id: "seg-mama-realizada",
          title: "Mamografia",
          subTitle: "Convocações realizadas",
          value: dashboard.mama?.realizadas || 0,
          categorias: formatCategorias(dashboard.mama?.categorias),
          tone: "success",
        },
      ],
      table: {
        items: (data?.content || []).map((item) => ({
          id: item.id,
          pessoaId: item.pessoaId,
          nome: item.paciente,
          anoPlanejado: item.anoPlanejado,
          mesPlanejado: item.mesPlanejado,
          dataReferencia: item.dataReferencia,
          statusGeralRastreamento: item.statusGeralRastreamento,
          categoria: item.categoria,
          prioridade: item.categoria,
          cpf: item.cpf,
          idade: item.idade,
          exame: item.exameIndicado,
          ultimoExame: item.dataReferencia,
          prazoRecomendado: item.dataValidadeDiretriz,
          ubs: item.ubs,
          telefone: item.telefone,
          endereco: item.endereco,
          convocada: item.status === "CONVOCADO",
          status: item.status,
        })),
        total: data?.totalElements ?? data?.content?.length ?? 0,
      },
    };
  }


  await wait();

  const byExam = filterByExam(seguimentoRows, exame);
  const byPriority =
    prioridade && prioridade !== "TODAS"
      ? byExam.filter((row) => row.prioridade === prioridade)
      : byExam;
  const filtered = byPriority.filter((row) => matchesSearch(row, busca));
  const sorted = [...filtered].sort((a, b) => {
    const priorityOrder = { Alta: 0, Média: 1, Baixa: 2 };
    return (priorityOrder[a.prioridade] ?? 3) - (priorityOrder[b.prioridade] ?? 3);
  });
  const pagination = paginate(sorted, page, size);

  return {
    table: pagination,
  };
};

export const convocarPacientes = async ({ tipo, ids, usuarioId }) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    return { updated: 0 };
  }

  if (
    (tipo === "rastreamento" && USE_REAL_RASTREAMENTO_CONVOCAR) ||
    (tipo === "seguimento" && USE_REAL_SEGUIMENTO_CONVOCAR)
  ) {
    const { data } = await api.post("/api/tracking/convocacoes/convocar", {
      itemIds: ids,
      usuarioId,
      origem: tipo === "seguimento" ? "SEGUIMENTO" : "RASTREAMENTO",
    });
    return data;
  }

  await wait(150);

  if (tipo === "rastreamento") {
    rastreamentoRows = rastreamentoRows.map((row) =>
      ids.includes(row.id) ? { ...row, convocada: true } : row,
    );
  }

  if (tipo === "seguimento") {
    seguimentoRows = seguimentoRows.map((row) =>
      ids.includes(row.id) ? { ...row, convocada: true } : row,
    );
  }

  return { updated: ids.length };
};

export const exportarConvocacaoCsv = async ({ tipo, filtros }) => {
  if (
    (tipo === "rastreamento" && USE_REAL_RASTREAMENTO_EXPORTAR) ||
    (tipo === "seguimento" && USE_REAL_SEGUIMENTO_EXPORTAR)
  ) {
    const { data } = await api.get("/api/tracking/convocacoes/itens/exportar-xls", {
      params: {
        origem: tipo === "seguimento" ? "SEGUIMENTO" : "RASTREAMENTO",
        idOrganograma: filtros.idOrganograma,
        tipoRastreamento:
          filtros.exame === "Mama"
            ? "MAMA"
            : filtros.exame === "Colo"
              ? "CITO"
              : undefined,
        ano: filtros.ano || undefined,
        mes: filtros.mes || undefined,
        categoria:
          tipo === "seguimento" && filtros.prioridade !== "TODAS"
            ? filtros.prioridade
            : undefined,
        status: filtros.status || undefined,
      },
      responseType: "blob",
    });
    return data;
  }

  await wait(120);

  if (tipo === "rastreamento") {
    const byExam = filterByExam(rastreamentoRows, filtros.exame);
    const byYear = filtros.ano
      ? byExam.filter((row) => row.anoConvocacao === filtros.ano)
      : byExam;
    const byMonth = filtros.mes
      ? byYear.filter((row) => row.mesConvocacao === filtros.mes)
      : byYear;
    const filtered = byMonth.filter((row) => matchesSearch(row, filtros.busca));
    return toCsv(filtered);
  }

  const byExam = filterByExam(seguimentoRows, filtros.exame);
  const byPriority =
    filtros.prioridade && filtros.prioridade !== "TODAS"
      ? byExam.filter((row) => row.prioridade === filtros.prioridade)
      : byExam;
  const filtered = byPriority.filter((row) => matchesSearch(row, filtros.busca));
  return toCsv(filtered);
};

export const getConvocacaoMeta = () => ({
  months: monthLabels,
  examOptions: [
    { value: "TODOS", label: "Todos" },
    { value: "Colo", label: "Colo do Útero" },
    { value: "Mama", label: "Mama" },
  ],
  priorityOptions: [
    { value: "TODAS", label: "Todas" },
    { value: "Alta", label: "Alta" },
    { value: "Média", label: "Média" },
    { value: "Baixa", label: "Baixa" },
  ],
});
